var React = require('react');

function MagnifyingGlass (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.19239","cy":"9.19238","r":"5.5","transform":"rotate(-45 9.19239 9.19238)","stroke":"white","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"14.1422","y1":"13.435","x2":"17.6777","y2":"16.9705","stroke":"white","strokeWidth":"2","key":1})]);
}

MagnifyingGlass.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = MagnifyingGlass;

MagnifyingGlass.default = MagnifyingGlass;
